const Storage =  {}

Storage.get = function (name) {
  return JSON.parse(localStorage.getItem(name))
}

Storage.set = function (name, val) {
  localStorage.setItem(name, JSON.stringify(val))
}

Storage.delete = function deleteItem (name) {
  localStorage.removeItem(name)
}

export default Storage


// WEBPACK FOOTER //
// ./src/common/js/localstorage.js